module.exports = __webpack_public_path__ + "static/media/hangman12.cc091c38.svg";